import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-light py-3 mt-5 border-top">
      <Container className="text-center text-muted">
        <p className="mb-0">&copy; {new Date().getFullYear()} Lagerverwaltungs-App | Version 1.0</p>
        <p className="small mb-0">Entwickelt für Handwerker</p>
      </Container>
    </footer>
  );
};

export default Footer;
